import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropdownCoordinatorService {
  private activeDropdownId = signal<string | null>(null);

  readonly currentActiveId = this.activeDropdownId.asReadonly();

  open(id: string): void {
    this.activeDropdownId.set(id);
  }

  close(id?: string): void {
    if (!id || this.activeDropdownId() === id) {
      this.activeDropdownId.set(null);
    }
  }

  toggle(id: string): void {
    if (this.isOpen(id)) {
      this.close(id);
    } else {
      this.open(id);
    }
  }

  isOpen(id: string): boolean {
    return this.activeDropdownId() === id;
  }

  closeAll(): void {
    this.activeDropdownId.set(null);
  }
}

